export {Avatar} from 'antd';
export type {AvatarProps} from 'antd/es/avatar/index';
